import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as RequestActions from '../../../actions/requestActions';
import PricingBoxSection from '../../custom/sections/PricingBoxSection';
import PDFInvoice from '../../custom/PDFInvoice';
import './index.css';


class Pricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfInfo:null
    }
    this.invoiceClickHandler = this.invoiceClickHandler.bind(this);
    this.downloadTariffsPDFClickHandler = this.downloadTariffsPDFClickHandler.bind(this);
  }

  invoiceClickHandler(pdfInfo){
    this.setState({pdfInfo});
  }

  downloadTariffsPDFClickHandler(){
    // var link = document.createElement("a");
    // link.download = 'تعرفه خدمات';
    // link.href = 'تعرفه خدمات.pdf';
    // link.click();
  }

  render() {
    const { lang, selectedPlan } = this.props;
    const { pdfInfo } = this.state;
    return (
      <div className='page-padding'>
        <PricingBoxSection lang={lang} onInvoiceClick={this.invoiceClickHandler}/>
        <section className='sc-pricing-page-info-sec'>
          <p>
            {lang === 'fa' ? 'جهت خرید اشتراک‌های چندکاربره و سازمانی با واحد فروش بورس ویو به شماره 81903-021 تماس حاصل بفرمایید' : ''}
          </p>
          <p>{lang==='fa'? 'مشتریان کارگزاری مفید امکان بهره مندی از امتیاز پلکان با تخفیف ویژه جهت استفاده از بورس ویو را دارند '
            :'Mofid securities clients can use pelekan points for buying BourseView subscription'}
          </p>
          {/* <p>{lang==='fa'? 'پرداخت از طریق کارت های عضو شبکه شتاب امکان پذیر است '
          :'you can use paypal for payment'}
          </p> */}
          <div className='sc-pricing-page-info-pdf-file'>
            {/* <div className='sc-pricing-page-info-pdf-file-wrapper' 
              style={{flexDirection:lang==='fa'? 'row':'row-reverse'}}
              onClick={this.downloadTariffsPDFClickHandler}
            >
              <img alt='' src={require('../../../assets/images/pdf.svg')}/>
              {lang==='fa'? 
                <div><span>تعرفه ها</span><span> PDF</span><span> دانلود فایل</span></div> :
                <div><span>Download</span><span> PDF</span><span> Tariffs File</span></div>
              }
            </div > */}
          </div>
        </section>
        <PDFInvoice lang={lang} selectedPlan={selectedPlan} pdfInfo={pdfInfo}/>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  lang: state.request.lang,
});


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    ...RequestActions,
  }, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(Pricing);
